import React, { forwardRef, useCallback, useEffect } from "react";
import {
  ThinkingIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  PartyIcon,
  HeartIcon,
  ApplauseIcon,
  SmileIcon,
} from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import Angie from "~/utils/angie.jsx";
import { useSoundContext } from "../Sounds/context/index.jsx";

const ReactionShortName = {
  thumbs_up: ThumbsUpIcon,
  thumbs_down: ThumbsDownIcon,
  smile: SmileIcon,
  applause: ApplauseIcon,
  thinking: ThinkingIcon,
  heart: HeartIcon,
  party: PartyIcon,
};

export const Reaction = forwardRef(({ shortName, count, reacted, pending, onClick, disableToggle, ...rest }, ref) => {
  const { play, preloadSound } = useSoundContext();

  const ReactionIcon = ReactionShortName[shortName];

  useEffect(() => {
    preloadSound(`${Angie.assets_url}/system/audio/reaction-sound.mp3`);
  }, [preloadSound]);

  const handleClick = useCallback(() => {
    if (!reacted) {
      play(`${Angie.assets_url}/system/audio/reaction-sound.mp3`);
    }
    if (!pending) {
      typeof onClick === "function" && onClick();
    }
  }, [onClick, pending, reacted, play]);

  return (
    <div
      {...rest}
      ref={ref}
      className={classnames(`reaction reaction_${shortName}`, {
        reacted,
        disabled: disableToggle,
      })}
      onClick={handleClick}
    >
      <span className="reaction_icon">
        <ReactionIcon />
      </span>
      {count > 0 && <span className="reaction_count">{count}</span>}
    </div>
  );
});

Reaction.propTypes = {
  shortName: PropTypes.string.isRequired,
  count: PropTypes.number,
  onClick: PropTypes.func,
  reacted: PropTypes.bool,
  pending: PropTypes.bool,
  disableToggle: PropTypes.bool,
};

Reaction.defaultProps = {
  count: 0,
  reacted: false,
  pending: false,
  disableToggle: false,
};

Reaction.displayName = "Reaction";
